import React from "react";
import HeaderLogo from "../../components/headerLogo/index";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

import {
  Container,
  Section,
  ContainerContato,
  ContainerForm,
  Button,
} from "./styles";
import Footer from "../../components/footer/index";
import TitlePage from "../../components/titlePage/index";
import AnimatedBackground from "../../components/background/index";

import {
  FaWhatsappSquare,
  FaPhoneSquareAlt,
  FaEnvelopeSquare,
  FaLinkedin,
  FaGithubSquare,
  FaFacebookSquare,
} from "react-icons/fa";


function Contato() {
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_qlz3tcq",
        "template_1n92obj",
        e.target,
        "mh8M1qjqSBT5Qcyyp"
      )
      .then(
        () => {
          toast.success("🧑‍💻 Mensagem enviada com sucesso", {
            theme: "dark",
            icon: false,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setInterval(() => {
            document.location.reload(true);
          }, 4000);
        },
        (error) => {
          if (error) {
            toast.error(`Error no envio da mensagem`, {
              theme: "dark",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
        }
      );
  }
  return (
    <>
      <AnimatedBackground />
      <Container>
        <HeaderLogo />
        <TitlePage subtitle="Contato" title="Entrar em contato" />
        <Section>
          <ContainerContato>
            <div>
              <h1>Contato alternativo</h1>
              <ul>
                <li>
                  <a target="blank" href="tel:(81)99928-0870">
                    <FaPhoneSquareAlt size={35} color="#4545E5" />
                  </a>
                  <a target="blank" href="tel:(81)99928-0870">
                    (81)99928-0870
                  </a>
                </li>
                <li>
                  <a target="blank" href="tel:(81)99928-0870">
                    <FaWhatsappSquare size={35} color="#4545E5" />
                  </a>
                  <a
                    target="blank"
                    href={"https://api.whatsapp.com/send?phone=5581999280870"}
                  >
                    Whatsapp
                  </a>
                </li>
                <li>
                  <a target="blank" href="tel:(81)99928-0870">
                    <FaEnvelopeSquare size={35} color="#4545E5" />
                  </a>
                  <a target="blank" href="mailto:eliedson.dev@gmail.com">
                    Email
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h1>Me siga</h1>
              <ul>
                <li>
                  <a
                    target="blank"
                    href="https://www.linkedin.com/in/eliedson-gomes/"
                  >
                    <FaLinkedin size={35} color="#4545E5" />
                  </a>
                </li>
                <li>
                  <a target="blank" href="https://github.com/Eliedson1979">
                    <FaGithubSquare size={35} color="#4545E5" />
                  </a>
                </li>
                <li>
                  <a
                    target="blank"
                    href="https://www.facebook.com/eliedsonsantos1979"
                  >
                    <FaFacebookSquare size={35} color="#4545E5" />
                  </a>
                </li>
              </ul>
            </div>
          </ContainerContato>
          <ContainerForm onSubmit={sendEmail}>
            <label>Envie uma mensagem</label>
            <div>
              <input type="text" name="user_name" placeholder="Nome" required />
              <input
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />
            </div>
            <textarea
              name="message"
              placeholder="Conte-me mais sobre sua necessidade....."
              required
            />
            <Button type="submit" value="Enviar" />
          </ContainerForm>
        </Section>
        <Footer />
      </Container>
    </>
  );
}

export default Contato;
